export default {
  maxLimit: "La limite maximale ne doit pas dépasser six chiffres.",
  emptyDeforestationStatus: "Le statut de déforestation EUDR est vide.",
  deleteFarmH: "Êtes-vous sûr de vouloir supprimer cette ferme ?",
  deleteFarmMsg:
    "Veuillez fournir une confirmation supplémentaire car supprimer cette ferme supprimera toutes les données liées à la ferme, telles que les cultures, les rapports, etc.",
  selectFileToUpload: "Sélectionnez un fichier pour télécharger les données.",
  totalRecords: "Nombre total d'enregistrements",
  success: "Succès",
  used: "Utilisé",
  recordsImported: "Enregistrements importés",
  psw: "Mot de passe",
  topFive: "Top 5",
  deleted: "Supprimé avec succès",
  failed: "Échec",
  fermentation: "Fermentation",
  confPsw: "Confirmez le mot de passe",
  newPsw: "Nouveau mot de passe",
  email: "E-mail",
  emailId: "ID e-mail",
  submit: "Soumettre",
  cancel: "Annuler",
  faqs: "FAQ",
  id: "ID",
  read: "Lu",
  unread: "Non lu",
  addFarm: "Ajouter une ferme",
  reset: "Réinitialiser",
  processor: "Processeur",
  cuppingScore: "Note de dégustation",
  label: "Étiquette",
  expiry: "Expiration",
  users: "Utilisateurs",
  language: "Langue",
  appUser: "Utilisateur de l'application",
  app_users: "Utilisateurs de l'application",
  offline_users: "Utilisateurs hors ligne",
  dimitraAdmin: "Administrateur Dimitra",
  admin_users: "Utilisateurs administrateurs",
  search: "Rechercher",
  searchByProducerName: "Rechercher par nom de producteur",
  searchBy: "Rechercher {type}",
  firstName: "Prénom",
  lastName: "Nom de famille",
  mobile: "Mobile",
  mobileNumber: "Numéro de mobile",
  department: "Département",
  departmentName: "Nom du département",
  role: "Rôle",
  status: "Statut",
  "Due Diligence Reports": "Rapports de diligence raisonnable",
  "EUDR Deforestation Assessments": "Évaluations de la déforestation EUDR",
  "Risk Assessments": "Évaluations des risques",
  Used: "Utilisé",
  permission: "Autorisations",
  activity_log: "Journal d'activité",
  profile_auth: "Authentification de profil",
  countryCode: "Code du pays",
  selectDept: "Sélectionnez un département",
  selectRole: "Sélectionnez un rôle",
  edit: "Modifier",
  update: "Mettre à jour",
  delete: "Supprimer",
  view: "Voir",
  VIEW: "Voir",
  deactivate: "Désactiver",
  activate: "Activer",
  serverError: "Quelque chose s'est mal passé. Veuillez réessayer plus tard.",
  minute: "Minute",
  perHour: "Par heure",
  day: "Jour",
  enterDescription: "Entrez votre description ici",
  enterHere: "Entrez ici",
  enterMobile: "Entrez le numéro de mobile",
  phoneRequired: "Le téléphone est requis",
  phoneValid: "Le téléphone doit être valide",
  unableToUpdate: "Impossible de mettre à jour",
  membershipPlans: "Plans d'adhésion",
  byWeek: "Par semaine",
  byMonth: "Par mois",
  byYear: "Par an",
  custom: "Personnalisé",
  name: "Nom",
  warehouse: "Entrepôt",
  regionState: "Région/État",
  hour: "Heures",
  days: "Jours",
  minutes: "Minutes",
  provinceState: "Province/État",
  cityTown: "Village/Ville",
  membershipValidity: "Validité de l'adhésion de base",
  basicPlanValidity: "Validité du plan de base",
  membershipExpiryDate: "Date d'expiration de l'adhésion",
  extendedValidity: "Validité prolongée",
  exportAsCSV: "Exporter en CSV",
  filterBy: "Filtrer par",
  clearAllFilters: "Effacer tous les filtres",
  autoCondition: "Conditions automatiques",
  conditional: "Conditionnel",
  comingSoon: "Bientôt disponible",
  userRole: "Rôle de l'utilisateur",
  addUserRole: "Ajouter un rôle d'utilisateur",
  editUserRole: "Modifier un rôle d'utilisateur",
  additionalInformationRequired: "Informations supplémentaires requises",
  back: "Retour",
  browse: "Parcourir",
  clearAll: "EFFACER TOUT",
  filterByRegion: "Filtrer par région",
  continue: "Continuer",
  resolveNow: "Résoudre maintenant",
  description: "Description",
  selectWeek: "Sélectionnez une semaine",
  hideSplash: "Masquer l'écran d'accueil ?",
  hideLogo: "Masquer le logo ?",
  confirm: "CONFIRMER",
  selectMonth: "Sélectionnez un mois",
  selectDateRange: "Sélectionnez une plage de dates",
  regionDistrict: "Région/District",
  address: "Adresse",
  familyTribe: "Famille/Tribu",
  website: "Site Web",
  deactivated: "Désactivé",
  active: "Actif",
  inactive: "Inactif",
  "Download Survey List": "Télécharger la liste des enquêtes",
  scheduled: "Planifié",
  country: "Pays",
  state: "État",
  farmer: "Agriculteur",
  commodity: "Produit",
  quantity: "Quantité",
  unit: "Unité",
  price: "Prix",
  save: "ENREGISTRER",
  remove: "Supprimer",
  stateIsReq: "L'état est requis",
  cityIsReq: "La ville est requise",
  addressIsReq: "L'adresse est requise",
  membershipTypeReq: "Le type d'adhésion est requis",
  extendedReasonReq: "La raison de l'extension est requise",
  numberOfDaysReq: "Le nombre de jours est requis",
  extendedMembershipValidity: "Validité de l'adhésion étendue",
  set: "DÉFINIR",
  adminRole: "Rôle administrateur",
  typeMsg: "Tapez votre message ici",
  manageFarmer: "Gérer les agriculteurs",
  manageOfflineFarmers: "Gérer les agriculteurs hors ligne",
  dashboardSettings: "Paramètres du tableau de bord",
  weightUnit: "Unité de poids",
  done: "Terminé",
  noRecordFound: "Aucun enregistrement trouvé",
  farmerName: "Nom de l'agriculteur",
  production: "Production",
  registered: "Enregistré",
  downloadForReport: "TÉLÉCHARGER LE RAPPORT PDF",
  downloadPdfReport: "Télécharger le rapport PDF",
  notifications: "Notifications",
  markAllAsRead: "Tout marquer comme lu",
  viewNotifications: "Voir les notifications",
  youAreUpToDate: "Vous êtes à jour",
  sendNotifications: "Notifications envoyées",
  createNotification: "Créer une notification",
  viewAllNotifications: "Voir toutes les notifications",
  createNotificationForGroup: "Créer une notification pour le groupe/utilisateurs multiples",
  createNotificationForDimitra: "Créer une notification pour l'administrateur Dimitra",
  note: "*Remarque : Seuls les fichiers MP4 sont pris en charge pour la vidéo",
  validMemberships: "Adhésions valides",
  memberShipPlanMessage: "Êtes-vous sûr de vouloir supprimer ce plan d'adhésion ?",
  deleteMemberShipPlan: "Supprimer le plan d'adhésion",
  systemAutoLogout: "Déconnexion automatique du système dans 2 minutes",
  monday: "Lundi",
  tuesday: "Mardi",
  Wednesday: "Mercredi",
  thursday: "Jeudi",
  friday: "Vendredi",
  saturday: "Samedi",
  sunday: "Dimanche",
  warning: "Avertissement",
  addnewOfflineFarmer: "Ajouter un nouvel agriculteur hors ligne",
  export: "Exporter",
  exportAs: "Exporter sous",
  createNewOfflineFarmer: "Créer un nouvel agriculteur hors ligne",
  offlineFarmerForByingStationOnly: "Agriculteur hors ligne uniquement pour la station d'achat (Local)",
  offlineFarmerForAllByingStations: "Agriculteur hors ligne pour toutes les stations d'achat (Global)",
  noDataAvailable: "Aucune donnée disponible",
  buyingStation: "Station d'achat",
  dryMillingStation: "Station de mouture sèche",
  mergeWithExistingAccount: "Fusionner avec un compte existant",
  createNewAccount: "Créer un nouveau compte",
  mobileOrEmailRequiredForRegister: "Pour enregistrer l'application, au moins un détail doit être fourni, soit le numéro de mobile, soit l'email.",
  selectLanguage: "Sélectionnez une langue",
  basicPlan: "Plan de base",
  local: "Local",
  newUser: "Nouvel utilisateur",
  merged: "Fusionné",
  global: "Global",
  qrcode: "Code QR",
  goBack: "Retour",
  profile: "Profil",
  pleaseChooseAnImageFile: "Veuillez choisir un fichier image",
  fileIsTooBigSelectUnder1MB: "Votre fichier est trop volumineux ! Veuillez sélectionner une image de moins de 1 Mo",
  pleaseTryAgainAfterSometime: "Veuillez réessayer plus tard",
  somethingWentWrong: "Quelque chose s'est mal passé.",
  passwordChangedSuccesFully: "Mot de passe modifié avec succès",
  passwordDoesNotMatch: "Les mots de passe ne correspondent pas",
  copyToCliped: "Copié dans le presse-papiers",
  profileUpdated: "Données du profil mises à jour.",
  emailAndMobileCantbeEmpty: "L'email et le mobile ne peuvent pas être vides.",
  changePassword: "Changer le mot de passe",
  generateSecurePassword: "Générer un mot de passe sécurisé",
  restoreDefault: "Restaurer par défaut",
  customization: "Personnalisation",
  recordsPerPage: "Enregistrements par page",
  Honey: "Miel",
  "Natural (Dry)": "Naturel (Sec)",
  Wine: "Vin",
  "Semi-Washed": "Semi-Lavé",
  "Full-Washed": "Entièrement Lavé",
  lessThanOneMonth: "Moins d'un mois",
  oneTo8Month: "1-8 mois",
  sixTo12Month: "6-12 mois",
  moreThanYear: "Plus d'un an",
  meter: "Mètre",
  kiloMeter: "Kilomètre",
  mile: "Mile",
  gram: "Gramme",
  kilogram: "Kilogramme",
  pound: "Livre",
  cubicKilo: "Kilomètre cube (km³)",
  cubicMeter: "Mètre cube (m³)",
  cubicCentimeter: "Centimètre cube (cm³)",
  cubicMilimeter: "Millimètre cube (mm³)",
  showingAll: "Afficher tout",
  emailSentSuccessfully: "E-mail envoyé avec succès",
  step: "Étape",
  fileError: "Erreur de fichier",
  ProvideFileFormat: "Remarque importante : Veuillez fournir les formats suivants (PNG/JPEG)",
  signHere: "Signez ici",
  numOfDaysRemaining: "Nombre de jours restants",
  requesterNameIsRequired: "Le nom du demandeur est requis",
  messageIsRequired: "Le message est requis",
  emailIsInvalid: "L'email est invalide",
  emailIsRequired: "L'email est requis",
  all: "Tous",
  filesSucessfullyUploaded: "Fichiers téléchargés avec succès.",

  unsynced_record: "Enregistrement non synchronisé",
  loadingData: "Chargement des données...",
  markAsRead: "Marquer comme lu",

  of: "de",
  ok: "OK",

  orderBy: "Trier par",
  select: "Sélectionner",
  type: "Type",
  uploadImageVideo: "Télécharger des images",
  user: "Utilisateur",
  userName: "Nom d'utilisateur",
  usersSelected: "Utilisateurs sélectionnés",
  topics: "Sujets",
  date: "Date",
  addNew: "AJOUTER NOUVEAU",
  exportAsCsv: "Exporter en CSV",
  noData: "Aucune donnée trouvée",

  dashboard: "Tableau de bord",
  mainDashboard: "Tableau de bord principal",
  userDashboard: "Tableau de bord utilisateur",
  areYouSureText: "Êtes-vous sûr de vouloir effectuer cette action.",

  cropsReport: "Rapport des cultures",
  today: "Aujourd'hui",
  week: "Semaine",
  month: "Mois",
  year: "Année",
  cropsStatistics: "Statistiques des cultures",
  crops: "Cultures",
  acres: "Acres",
  totalPlantedArea: "Superficie totale plantée",
  farmersChart: "Graphique des agriculteurs",
  cropsName: "Nom des cultures",
  farmers: "Agriculteurs",
  farms: "Fermes",
  planted: "Planté",
  plantedArea: "Zone plantée",
  harvested: "Récolté",
  yieldAcre: "Rendement/Acre",
  selectCrop: "Sélectionner une culture",
  listByYield: "Liste par rendement",
  listByPlantedArea: "Liste par zone plantée",
  equipmentReport: "Rapport d'équipement",
  equipmentChart: "Graphique des équipements",
  selectFarmer: "Sélectionner un agriculteur",
  selectFarmers: "Sélectionner des agriculteurs",
  equipmentName: "Nom de l'équipement",
  region: "Région",
  counts: "Comptes",
  large: "Grand",
  medium: "Moyen",
  small: "Petit",
  listByFarmer: "Liste par agriculteur",
  rowsPerPage: "Lignes par page",
  farmersReport: "Rapport des agriculteurs",
  farmsReport: "Rapport des fermes",
  farmersStatistics: "Statistiques des agriculteurs",
  farmStatistics: "Statistiques des fermes",
  averageFarmerLand: "Terre moyenne des agriculteurs",
  totalFarmerLand: "Terre totale des agriculteurs",
  largeFarmers: "Grands agriculteurs",
  mediumFarmers: "Agriculteurs moyens",
  smallFarmers: "Petits agriculteurs",
  listByLand: "Liste par terre",
  listByFarm: "Liste par ferme",
  AvgLandAcre: "Moy. Terre/Acre",
  listbyCrop: "Liste par culture",
  listbyZone: "Liste par zone",
  farmName: "Nom de la ferme",
  zones: "Zones",
  area: "Zone",
  goalsAchievedReport: "Rapport des objectifs atteints",
  listByCrops: "Liste par cultures",
  goalsAchievedChart: "Graphique des objectifs atteints",
  goalsAchieved: "Objectifs atteints",
  goalsFailed: "Objectifs échoués",
  successRate: "Taux de réussite",
  achieved: "Atteint",
  equipment: "Équipement",
  pests: "Ravageurs",
  regions: "Régions",
  filterByCrops: "Filtrer par cultures",
  searchCrops: "Rechercher des cultures",
  batchCode: "Code de lot",
  batchRating: "Évaluation du lot",
  MakeASelection: "Faire une sélection",
  typeTotalCoffeeQuantity: "Entrez la quantité totale de café",
  typeHumidity: "Entrez l'humidité",
  valueInPercent: "valeur en %",
  purchaseOrderRequired: "Commande requise",
  totalCoffeeCherryRequired: "Total des cerises de café requis",
  processTypeRequired: "Type de traitement requis",
  fermentationTypeRequired: "Type de fermentation requis",
  stationInfo: "Informations sur la station",
  purchaseOrders: "Commandes",
  processingBatch: "Lot de traitement",
  processedCoffeeOutRequired: "Café traité requis",
  lotNo: "N° de lot",
  addNewS: "Ajouter Nouveau",
  viewAll: "Voir tout",
  parchmentOut: "Sortie parchemin",
  processingDone: "Traitement terminé",
  farmerLotID: "ID agriculteur & lot",
  weight: "Poids",
  plantationSettings: "Paramètres de plantation",
  PlantationsEachFarmerCanCreate: "Nombre de plantations par agriculteur",
  manageAdditionalPlantationRequests: "Gérer les demandes supplémentaires",
  autoApprove: "Approbation automatique",
  adminApprovalRequired: "Approbation admin requise",
  close: "Fermer",
  new_user: "Nouvel utilisateur",
  KGAcre: "KG/Acre",

  // Sept 29, 2030
  honey: "Miel",
  naturalDry: "Naturel (Sec)",
  wine: "Vin",
  SemiWashed: "Semi-lavé",
  fullWashed: "Complètement lavé",
  startDateRequired: "Date de début requise",
  endDateRequired: "Date de fin requise",
  assigned: "Attribué",
  activated: "Activé",
  unassigned: "Non attribué",
  deleteTopic: "Supprimer le sujet",
  sureToDeleteTopic: "Êtes-vous sûr de vouloir supprimer le sujet des problèmes techniques?",
  publishSurvey: "Publier le sondage",
  endSurvey: "Terminer le sondage",
  copy: "Copier",
  pending: "En attente",

  // Dashboad Report Translation
  parchmentId: "ID parchemin",
  "Farmer Name": "Nom de l'agriculteur",
  "Goals Achieved": "Objectifs atteints",
  "Goals Failed": "Objectifs échoués",
  "Success Rate": "Taux de réussite",
  "Farm Size": "Taille de la ferme",
  "Small Farmer": "Petit agriculteur",
  "Medium Farmer": "Agriculteur moyen",
  "Large Farmer": "Grand agriculteur",

  "Equipment Name": "Nom de l'équipement",
  Farmer: "Agriculteur",
  Counts: "Comptes",

  "Pest Name": "Nom du ravageur",
  "Total Area": "Superficie totale",
  Region: "Région",
  Crop: "Culture",

  "Crop Name": "Nom de la culture",
  Farmers: "Agriculteurs",
  Farms: "Fermes",
  Planted: "Planté",
  "Planted Area": "Zone plantée",
  Harvested: "Récolté",
  "Yield/acre": "Rendement/acre",
  "Region Name": "Nom de la région",

  "Avg. Land/Acre": "Moyenne des terres/acre",
  Crops: "Cultures",
  "Yield/area": "Rendement/surface",
  "Avg. land/Acre": "Moyenne des terres/acre",

  "Farm Name": "Nom de la ferme",
  Zones: "Zones",
  Area: "Surface",

  "Goals Achieved Report": "Rapport sur les objectifs atteints",
  "Farms Report": "Rapport sur les fermes",
  "Pest Report": "Rapport sur les nuisibles",
  "Equipment Report": "Rapport sur les équipements",
  "Crops Report": "Rapport sur les cultures",
  "Farmers Report": "Rapport sur les agriculteurs",
  "Regional Report": "Rapport régional",
  fermentationCode: "Code de fermentation",

  months: "Mois",
  open: "Ouvert",
  closed: "Fermé",
  moreInfoRequired: "Plus d'informations requises",
  fieldRequired: "Ce champ est requis.",
  valueMustBeGreaterThanZero: "La valeur doit être supérieure à zéro.",
  valueExceedsLimit: "Le délai d'expiration ne peut pas dépasser 12 mois conformément aux réglementations EUDR.",
  valueMustBeInteger: "La valeur doit être un entier.",
  viewAssessmentDetails: "Voir les détails de l'évaluation",
  viewDeforestationDetails: "Voir les détails de la déforestation",
  listOfShipments: "Liste des expéditions",
  viewShipment: "Voir l'expédition",
  shipmentCratedSuccess: "L'expédition a été créée avec succès.",
  pleaseSelectAtLeastOneDueDeligenceReport: "Veuillez sélectionner au moins un rapport de diligence raisonnable",
  confirmation: "Confirmation",

  "Day/s": "Jour/s",
  "Month/s": "Mois/s",
  "Year/s": "Année/s",
  "Hour/s": "Heure/s",
  "Minute/s": "Minute/s",
  "Second/s": "Seconde/s",
  "Week/s": "Semaine/s",
  show: "Afficher",

  noUploadToBlockchain: "Aucun téléchargement vers la blockchain",
  noDataForBlockchain: "Comme aucun rapport de déforestation n'a été généré pour les lieux de production, il n'y avait aucune donnée à écrire sur la blockchain. Si cela était inattendu, veuillez vous assurer que les rapports pour les fermes ont été correctement générés dans les étapes précédentes.",
  pleaseAgreeToDeclaration: "Veuillez accepter la déclaration pour conclure.",
  importProductionPlaceTT: "Permet aux utilisateurs d'importer des données sur les lieux de production à l'aide de l'importation ou du téléchargement de fichiers.",
  defaultCircularGeofence: "Les fermes sans périmètre ou sans information sur leur taille se verront attribuer un périmètre circulaire par défaut de 4 hectares. Si la taille moyenne des fermes est inférieure à 4 hectares, veuillez modifier la taille par défaut en cliquant sur le bouton 'Modifier' ci-dessous.",
  accordingToEUDRFarmsWithLessThan4HectaresDoNotRequireAPolygon: "Selon l'EUDR, les fermes de moins de 4 hectares n'ont pas besoin de polygone.",
  uploadOneDeforestationAssessmentForAllFarms: "TÉLÉCHARGER UNE ÉVALUATION DE DÉFORESTATION POUR TOUTES LES FERMES",
  uploadAssessment: "Télécharger l'évaluation",

  timeAgo: {
    minute: "il y a une minute",
    minutes: "il y a {count} minutes",
    hour: "il y a une heure",
    hours: "il y a {count} heures",
    day: "il y a un jour",
    days: "il y a {count} jours",
    month: "il y a un mois",
    months: "il y a {count} mois",
    year: "il y a un an",
    years: "il y a {count} ans"
  },

  tickets: {
    actions: {
      create: "Créer un ticket",
      delete: "Supprimer le ticket",
      edit: "Modifier le ticket"
    },
    areaOfRequest: "Domaine de la demande",
    assignee: "Assigné",
    deleteTicket: {
      confirmation: "Êtes-vous sûr de vouloir supprimer le ticket {0} ?"
    },
    dueDate: "Date d'échéance",
    filters: {
      ticketFor: "Ticket pour"
    },
    form: {
      ticketType: {
        admin: "Créer un ticket pour l'administrateur Dimitra",
        user: "Créer un ticket pour l'utilisateur de l'application"
      }
    },
    markAsRead: "Marquer comme lu",
    messages: {
      created: {
        success: "Ticket créé avec succès"
      },
      deleted: {
        success: "Ticket supprimé avec succès"
      }
    },
    noData: "Aucun ticket trouvé !",
    noDataHelpText: "Vous n'avez encore aucun ticket assigné à {0} vous. Cliquez sur le bouton 'Créer un ticket' {1} en haut de cet écran pour commencer.",
    pickerInMenu: "Sélecteur dans le menu",
    priority: {
      high: "Élevé",
      label: "Priorité"
    },
    reply: "Répondre",
    requestedDateTime: "Date et heure demandées",
    requestorDetails: "Détails du demandeur",
    requestorEmail: "Email du demandeur",
    subject: "Sujet",
    ticketsForItems: {
      all: "Tous",
      dimitraAdmin: "Administrateur Dimitra",
      multipleUsers: "Utilisateurs multiples",
      singleUser: "Utilisateur unique"
    },
    title: "Tickets"
  },

  faqSection: {
    createFaq: "CRÉER UNE FAQ",
    createTopic: "Créer un sujet",
    selectTopic: "Sélectionner un sujet",
    faqQuestion: "Question FAQ",
    faqAnswer: "Réponse FAQ",
    uploadImgVid: "Télécharger une image/vidéo",
    disInFaq: "Afficher dans la section FAQ",
    editFaq: "Modifier la FAQ",
    topicName: "Nom du sujet",
    parentTopic: "Sujet parent",
    editTopic: "Modifier le sujet",
    createSection: "Veuillez d'abord créer une section",
    createTopicFirst: "Veuillez d'abord créer un sujet",
    questionReq: "La question FAQ est requise",
    answerReq: "La réponse FAQ est requise"
  },

  confirmDialog: {
    assessmentBuilder: {
      delete: {
        title: "Supprimer l'évaluation",
        message: "Êtes-vous sûr de vouloir supprimer l'évaluation ?",
        confirmBtn: "Confirmer ?"
      }
    },
    dueDiligenceReport: {
      delete: {
        title: "Supprimer le rapport de diligence raisonnable EUDR",
        message: "Êtes-vous sûr de vouloir supprimer le rapport de diligence raisonnable EUDR ?",
        confirmBtn: "Confirmer"
      }
    },
    farm: {
      delete: {
        title: "Supprimer la ferme",
        message: "Êtes-vous sûr de vouloir supprimer la ferme ?",
        confirmBtn: "Confirmer"
      }
    },
    status: {
      delete: {
        title: "Supprimer l'état de la déforestation",
        message: "Êtes-vous sûr de vouloir supprimer l'état de la déforestation ?",
        confirmBtn: "Confirmer"
      }
    }
  },

  countries: "Pays",
  tutorials: {
    howtoCreateanAdminUser: "Comment créer un utilisateur administrateur",
    howToCreateanActivationKey: "Comment créer une clé d'activation",
    individualandBulkFarmCreation: "Création individuelle et en masse de fermes",
    creatingaDueDiligenceStatement: "Création d'une déclaration de diligence raisonnable",
    title: "Tutoriels et guides",
    noTutorials: "Aucun tutoriel",
    addTutorialPrompt: "Veuillez d'abord ajouter un tutoriel ou un guide.",
    videoNotAvailable: "Vidéo non disponible dans votre langue préférée.",
    watchVideo: "Regarder la vidéo",
    viewTutorial: "Voir le tutoriel",
    // Kenyan tutorials
    creatingAndManagingUsers: "Création et gestion des utilisateurs",
    howToCreateActivationKeys: "Comment créer des clés d'activation",
    userRolesAndPermissions: "Rôles et permissions des utilisateurs",
    creatingAFarm: "Création d'une ferme",
    creatingADueDiligenceStatement: "Création d'une déclaration de diligence raisonnable",
    sharingStatementWithOperator: "Partage de déclaration avec l'opérateur",
    riskMitigation: "Atténuation des risques",
    generalSettings: "Paramètres généraux",
    assessmentBuilder: "Générateur d'évaluation",
    bulkUserUpload: "Téléchargement en lot d'utilisateurs",
    excludeGlobalForOrg: "Exclure les tutoriels globaux pour l'organisation",
    exclusionUpdateSuccess: "Configuration des tutoriels de l'organisation mise à jour avec succès",
    exclusionUpdateError: "Erreur lors de la mise à jour de la configuration des tutoriels de l'organisation",
    exclusionStatusLoadError: "Erreur lors du chargement de la configuration des tutoriels de l'organisation",

  },

  helpDesk: "Assistance",
}